import { IDeleteOutputDto } from './delete-output-dto.interface';
import { ITagOutputDto } from './tags-output-dto.interface';

export interface IAccountOutputDto extends IDeleteOutputDto {
    id: string;
    organizationId?: string;
    name: string;
    code: string;
    businessName: string;
    country: string;
    address?: string;
    vatNumber: string;
    externalOrganizationId: string;
    email: string;
    externalId?: string;
    locations?: string[];
    tags?: string[] | ITagOutputDto[];
    phoneNumber?: string;
    createdAt?: string;
    updatedAt?: string;
}
